<template>
    <div class="animated fadeIn">
        <div v-if="loading">
            <b-row>
                <b-col cols="12" md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <b-row v-else>
            <b-col cols="12" md="12">
                <b-col cols="12" md="12">
                    <component-header
                        title="Attribute"
                        :isLoading="isLoading"
                        :hasSearch="true"
                        :hasReload="true"
                        @search-query="onSearchQuery"
                        @reload-data="reloadData"
                        createButtonText="Create Attribute"
                        @create-press="onClickAddPermission"
                    />
                </b-col>
                <b-card class="card-wrap" border-variant="info">
                    <div>
                        <b-table
                            class="rounded-card mt-3"
                            :dark="dark"
                            :hover="hover"
                            :striped="striped"
                            :bordered="bordered"
                            :small="small"
                            :fixed="fixed"
                            responsive="sm"
                            :items="filteredList"
                            :fields="captions"
                            thead-class="header"
                            show-empty
                            :busy="loading"
                            @filtered="onFilter"
                        >
                            <template slot="cell(action)" slot-scope="data">
                                <div class="inline_btnTable">
                                    <ActionButtonGroup
                                        showView
                                        showEdit
                                        showDelete
                                        @view="
                                            $router.push({
                                                name: 'ViewAttribute',
                                                params: { id: data.item._id },
                                            })
                                        "
                                        @edit="
                                            $router.push({
                                                name: 'AttributeForm',
                                                params: { id: data.item._id },
                                            })
                                        "
                                        @delete="deleteAttribute(data)"
                                    />
                                </div>
                            </template>

                            <div
                                slot="table-busy"
                                class="text-center text-danger my-2"
                            >
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </b-table>
                    </div>
                    <div class="d-flex justify-content-end">
                        <b-pagination
                            align="right"
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="totalRows"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        />
                    </div>
                </b-card>
                <!-- </b-card> -->
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";

export default {
    name: "viewattribute",
    components: {
        AtomSpinner,
        ComponentHeader,
        ActionButtonGroup,
    },
    data: () => {
        return {
            filterCount: 0,
            loading: false,
            items: [],
            tableFields: [
                {
                    key: "attributeName",
                    label: "Field Name",
                    sortable: true,
                    thStyle: { width: "180px" },
                },
                {
                    key: "attributeValueType",
                    label: "Type",
                    sortable: true,
                    thStyle: { width: "150px" },
                },
                {
                    key: "description",
                    label: "Description",
                    sortable: true,
                    thStyle: { width: "270px" },
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: { width: "180px" },
                },
            ],

            filter: "",
            caption: "Table",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            tableData: [],
            perPage: 10,
            loading: false,
            currentPage: 1,
            dark: false,
        };
    },
    methods: {
        onClickAddPermission() {
            this.$router.push({ name: "CreateAttribute" });
        },

        onSearchQuery(val) {
            this.filter = (val || "").trim();
            this.currentPage = 1;
        },
        reloadData() {
            this.loading = true;
            this.$store
                .dispatch("attribute/getAttributesList")
                .catch((error) => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        getRowCount() {
            return this.attributelist.length;
        },
        async deleteAttribute(data) {
            this.$swal({
                title: "Delete this attribute?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true,
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("attribute/deleteAttribute", data.item._id)
                        .then(async (result) => {
                            if (result.status === 1) {
                                this.$swal({
                                    title: "Congratulation",
                                    text: "Attribute has been deleted Successfully",
                                    type: "success",
                                });
                                this.loading = true;
                                await this.$store
                                    .dispatch("attribute/getAttributesList")
                                    .catch((error) => {
                                        this.$toasted.error(error.message);
                                    });
                                this.loading = false;
                            } else {
                                this.$toasted.error(
                                    result.response.data.message
                                        ? result.response.data.message
                                        : result.response.statusText,
                                );
                            }
                        });
                }
            });
        },
    },
    mounted: function () {
        this.$nextTick(async function () {
            this.loading = true;
            await this.$store
                .dispatch("attribute/getAttributesList")
                .catch((error) => {
                    this.$toasted.error(error.message);
                });
            this.loading = false;
        });
    },
    computed: {
        totalRows() {
            return this.getRowCount();
        },
        captions() {
            return this.tableFields;
        },
        attributelist() {
            return this.$store.getters["attribute/GetAttributeList"];
        },
        filteredList() {
            const filter = this.filter.toLowerCase();
            const filtered = this.attributelist.filter((item) => {
                return (
                    (item.attributeName || "") +
                    (item.description || "") +
                    (item.attributeValueType || "")
                )
                    .toLowerCase()
                    .includes(filter);
            });
            this.filterCount = filtered.length;
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return filtered.slice(start, end);
        },
    },
};
</script>
<style scoped>
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}
.header-font {
    font-weight: 700;
    font-size: medium;
}
.rounded-card {
    border-radius: 12px;
}

.btn-warning {
    background: #fe7b08;
    border: #fe7b08;
}

.btn-warning:hover {
    background: #e66a00;
    border-color: #e66a00;
}
.inline_btnTable {
    display: flex;
    gap: 6px;
    flex-wrap: nowrap;
}

.inline_btnTable .btn {
    flex-shrink: 0;
    min-width: 30px;
    min-height: 30px;
}
</style>
